import script from "./formula.vue?vue&type=script&setup=true&lang=js"
export * from "./formula.vue?vue&type=script&setup=true&lang=js"

import "./formula.vue?vue&type=style&index=0&id=2232a599&lang=less&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2232a599"]])

export default __exports__